/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Members_TitleInputs */



/**
* | output |
* | --- |
* | "No members yet" |
*
* @param {Team_Manager_No_Members_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_members_title = /** @type {((inputs?: Team_Manager_No_Members_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Members_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun membre pour l'instant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Mitglieder")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ancora nessun membro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пока нет участников")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no hay miembros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("まだメンバーがいません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी कोई सदस्य नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ainda sem membros")
	return /** @type {LocalizedString} */ ("No members yet")
});